var _defs, _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 900,
    height: 600,
    viewBox: "0 0 90 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 45 30L0 60z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h90v60H0z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e03c31",
    d: "M0 0h90v30H45z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#001489",
    d: "M0 60h90V30H45z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 20,
    d: "M90 30H45L0 0v60l45-30"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#ffb81c",
    strokeWidth: 20,
    clipPath: "url(#b)",
    d: "m0 0 45 30L0 60"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#007749",
    strokeWidth: 12,
    d: "m0 0 45 30h45M0 60l45-30"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZa);
export default __webpack_public_path__ + "static/media/za.8dab665f0fc25a95c04c9ff3fa801737.svg";
export { ForwardRef as ReactComponent };